import classNames from 'classnames';
import { FunctionComponent, HTMLAttributes, ReactNode } from 'react';
import styled from 'styled-components';

interface AsideButtonWrapperProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  level: 1 | 2;
}

const UnstyledAsideButtonWrapper: FunctionComponent<AsideButtonWrapperProps> = (props) => {
  const { children, level, ...otherProps } = props;

  return (
    <div
      {...otherProps}
      className={classNames({
        aside__button: true,
        [`aside__button--level-${level}`]: level,
        [`${otherProps?.className}`]: !!otherProps?.className
      })}
    >
      {children}
    </div>
  );
};

const StyledAsideButtonWrapper = styled(UnstyledAsideButtonWrapper)`
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-bottom-color: ${({ level }) => (level === 1 ? '#555' : '#666')};
  padding-bottom: 10px;
  margin-bottom: 10px;

  &:last-of-type {
    border-bottom: 0;
    padding-bottom: 0;
    margin-bottom: 0;
  }
`;

export const AsideButtonWrapper: FunctionComponent<AsideButtonWrapperProps> = (props) => {
  return <StyledAsideButtonWrapper {...props} />;
};
